(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paz-community-voices"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('paz-voices'))customElements.define('paz-voices',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.events=new AbortController();const signal=this.events.signal;
  this.track=this.querySelector('[data-voices-track]');this.cards=Array.from(this.querySelectorAll('[data-voices-card]')).sort((a,b)=>Number(b.dataset.date)-Number(a.dataset.date));const fragment=document.createDocumentFragment();this.cards.forEach(card=>fragment.append(card));this.track.append(fragment);requestAnimationFrame(()=>{this.track.scrollTo({left:0,behavior:'instant'});this.index=0;this.position();});this.filtered=this.cards;this.index=0;this.expanded=false;this.inView=false;this.userPaused=false;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.motionOverride=false;this.timer=null;
  this.querySelectorAll('[data-voices-controls]').forEach(e=>e.hidden=false);
  this.querySelectorAll('[data-voices-filter]').forEach(button=>{const source=button.dataset.voicesFilter;button.hidden=source!=='all'&&!this.cards.some(c=>c.dataset.kind===source);button.addEventListener('click',()=>{this.userPaused=true;this.index=0;this.querySelectorAll('[data-voices-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.cards.forEach(c=>c.hidden=source!=='all'&&c.dataset.kind!==source);this.filtered=this.cards.filter(c=>!c.hidden);this.track.scrollTo({left:0,top:0,behavior:'instant'});this.update();},{signal});});
  this.querySelector('[data-voices-prev]').addEventListener('click',()=>{this.userPaused=true;this.go(-1);},{signal});this.querySelector('[data-voices-next]').addEventListener('click',()=>{this.userPaused=true;this.go(1);},{signal});
  this.querySelector('[data-voices-toggle]').addEventListener('click',()=>{if(this.paused()){this.userPaused=false;this.motionOverride=true;this.go(1);}else this.userPaused=true;this.update();},{signal});
  this.querySelector('[data-voices-expand]').addEventListener('click',()=>{this.expanded=!this.expanded;this.dataset.expanded=String(this.expanded);this.userPaused=true;this.querySelector('[data-voices-expand]').setAttribute('aria-expanded',String(this.expanded));this.querySelector('[data-voices-view-all]').hidden=this.expanded;this.querySelector('[data-voices-view-less]').hidden=!this.expanded;this.track.scrollTo({left:0,top:0,behavior:'instant'});this.index=0;this.update();},{signal});
  const preferenceChanged=()=>{this.motionOverride=false;this.update();};this.motion.addEventListener('change',preferenceChanged,{signal});document.addEventListener('paz:motion-change',preferenceChanged,{signal});
  this.track.addEventListener('pointerenter',()=>{this.hovered=true;this.schedule();},{signal});this.track.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},{signal});this.track.addEventListener('focusin',()=>this.schedule(),{signal});this.track.addEventListener('focusout',()=>requestAnimationFrame(()=>this.schedule()),{signal});
  this.track.addEventListener('pointerdown',()=>{this.userPaused=true;this.update();},{signal});this.track.addEventListener('keydown',()=>{this.userPaused=true;this.update();},{signal});this.track.addEventListener('toggle',event=>{if(event.target.open){this.userPaused=true;this.update();}},{capture:true,signal});
  this.track.addEventListener('scroll',()=>{if(this.expanded)return;clearTimeout(this.scrollTimer);this.scrollTimer=setTimeout(()=>{let best=Infinity;const left=this.track.getBoundingClientRect().left;this.filtered.forEach((card,index)=>{const delta=Math.abs(card.getBoundingClientRect().left-left);if(delta<best){best=delta;this.index=index;}});this.position();},100);},{passive:true,signal});
  document.addEventListener('visibilitychange',()=>this.schedule(),{signal});this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.schedule();},{threshold:.15});this.observer.observe(this);this.update();
 }
 paused(){return this.userPaused||(!this.motionOverride&&(this.motion.matches||document.body.classList.contains('paz-reduce-motion')))||(!this.motionOverride&&this.dataset.autoplay!=='true');}
 update(){const paused=this.paused();this.querySelector('[data-voices-pause]').hidden=paused;this.querySelector('[data-voices-play]').hidden=!paused;this.querySelector('[data-voices-toggle]').setAttribute('aria-pressed',String(paused));this.position();this.schedule();}
 position(){const n=this.filtered.length;this.querySelector('[data-voices-position]').textContent=n?`${String(this.index+1).padStart(2,'0')} / ${n}`:'0 / 0';this.querySelector('[data-voices-prev]').disabled=n<2;this.querySelector('[data-voices-next]').disabled=n<2;}
 go(step){if(!this.filtered.length)return;const visible=Math.max(1,Math.floor((this.track.clientWidth+16)/(this.filtered[0].getBoundingClientRect().width+16)));const positions=Math.max(1,this.filtered.length-visible+1);this.index=(this.index+step+positions)%positions;const card=this.filtered[this.index];const left=card.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft;this.track.scrollTo({left,behavior:this.motion.matches||document.body.classList.contains('paz-reduce-motion')?'instant':'smooth'});this.position();this.schedule();}
 schedule(){clearTimeout(this.timer);if(this.paused()||this.expanded||!this.inView||this.hovered||this.track.matches(':focus-within')||document.hidden||this.filtered.length<2)return;this.timer=setTimeout(()=>this.go(1),Math.max(7,Number(this.dataset.seconds)||9)*1000);}
 disconnectedCallback(){this.events?.abort();this.observer?.disconnect();clearTimeout(this.timer);clearTimeout(this.scrollTimer);this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paz-experience"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('paz-slider')) {
  customElements.define('paz-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.paz-slider-track');
      this.slides = Array.from(this.querySelectorAll('.paz-slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));
      this.index = 0;
      this.userPaused = false;
      this.hovered = false;
      this.inView = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onVisibility = () => this.schedule();
      this.onMotion = () => this.schedule();
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-slide-prev')) this.go(this.index - 1, true);
        if (button.hasAttribute('data-slide-next')) this.go(this.index + 1, true);
        if (button.hasAttribute('data-slide-to')) this.go(Number(button.dataset.slideTo), true);
        if (button.hasAttribute('data-slide-pause')) {
          this.userPaused = !this.userPaused;
          button.setAttribute('aria-pressed', String(this.userPaused));
          button.querySelector('[data-pause-label]').hidden = this.userPaused;
          button.querySelector('[data-resume-label]').hidden = !this.userPaused;
          this.schedule();
        }
      });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
          this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
        });
      }, { passive: true });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); });
      this.addEventListener('focusin', () => this.schedule());
      this.addEventListener('focusout', () => requestAnimationFrame(() => this.schedule()));
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      document.addEventListener('paz:motion-change', this.onMotion);
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.2 });
      this.observer.observe(this);
      this.schedule();
    }
    go(index, announce) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: this.motion.matches || document.body.classList.contains('paz-reduce-motion') ? 'instant' : 'smooth' });
      if (announce) this.querySelector('[data-slide-status]').textContent = this.slides[this.index].getAttribute('aria-label');
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.userPaused || this.hovered || this.motion.matches || document.body.classList.contains('paz-reduce-motion') || document.hidden || !this.inView || this.contains(document.activeElement) || this.slides.length < 2) return;
      this.timer = setTimeout(() => this.go(this.index + 1, false), Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
      if (this.observer) this.observer.disconnect();
      if (this.motion) this.motion.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('paz:motion-change', this.onMotion);
      this.ready = false;
    }
  });
}
if (!customElements.get('paz-explorer')) {
  customElements.define('paz-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const select = index => {
        tabs.forEach((tab, number) => { tab.setAttribute('aria-selected', String(number === index)); tab.tabIndex = number === index ? 0 : -1; panels[number].hidden = number !== index; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); select(next); tabs[next].focus();
        });
      });
    }
  });
}
if (!customElements.get('paz-ticker')) {
  customElements.define('paz-ticker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.events = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userChoice = null;
      const button = this.querySelector('button');
      this.updateMotion = () => {
        const paused = this.userChoice ?? (this.motion.matches || document.body.classList.contains('paz-reduce-motion'));
        this.classList.toggle('is-paused', paused);
        this.dataset.motion = paused ? 'paused' : 'playing';
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('[data-pause-label]').hidden = paused;
        button.querySelector('[data-resume-label]').hidden = !paused;
      };
      button.addEventListener('click', () => {
        this.userChoice = !this.classList.contains('is-paused');
        this.updateMotion();
      }, { signal: this.events.signal });
      const preferenceChanged = () => {
        this.userChoice = null;
        this.updateMotion();
      };
      this.motion.addEventListener('change', preferenceChanged, { signal: this.events.signal });
      document.addEventListener('paz:motion-change', preferenceChanged, { signal: this.events.signal });
      this.updateMotion();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paz-plant-finder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('paz-plant-finder')){customElements.define('paz-plant-finder',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const form=this.querySelector('[data-finder-form]'),area=this.querySelector('[data-finder-area]'),status=this.querySelector('[data-finder-status]'),validation=this.querySelector('[data-finder-validation]'),groups=Array.from(this.querySelectorAll('[data-finder-result]')),lowAdvice=this.querySelector('[data-finder-low]');
const clear=()=>{groups.forEach(x=>x.hidden=true);lowAdvice.hidden=true;};
const show=(moveFocus)=>{
const values=new FormData(form),missing=Array.from(form.querySelectorAll('select[required]')).filter(x=>!x.value);
form.querySelectorAll('select').forEach(x=>x.setAttribute('aria-invalid',x.value?'false':'true'));
clear();
if(missing.length){area.hidden=true;validation.hidden=false;if(moveFocus)missing[0].focus();return;}
validation.hidden=true;area.hidden=false;
const low=values.get('light')==='low',key=values.get('format')==='display'?'display':values.get('format')+'-'+values.get('style'),result=groups.find(x=>x.dataset.finderResult===key);
lowAdvice.hidden=!low;this.querySelector('[data-finder-note]').hidden=false;
if(result){result.hidden=false;const hasProducts=!!result.querySelector('.paz-finder-card');result.querySelector('[data-finder-empty]').hidden=hasProducts;status.textContent=low?status.dataset.low:hasProducts?status.dataset.normal:status.dataset.empty;}
else{status.textContent=status.dataset.empty;const fallback=groups.find(x=>x.dataset.finderResult==='single-green');if(fallback){fallback.hidden=false;fallback.querySelector('[data-finder-empty]').hidden=false;}}
if(moveFocus){const header=document.querySelector('#header-group');area.style.scrollMarginTop=((header?header.getBoundingClientRect().height:180)+20)+'px';status.focus({preventScroll:true});const reduced=document.body.classList.contains('paz-reduce-motion')||window.matchMedia('(prefers-reduced-motion: reduce)').matches;area.scrollIntoView({block:'start',behavior:reduced?'auto':'smooth'});}
};
form.addEventListener('submit',event=>{event.preventDefault();show(true);});
form.addEventListener('change',()=>{if(!area.hidden||!validation.hidden)show(false);});
form.addEventListener('reset',()=>{clear();area.hidden=true;validation.hidden=true;form.querySelectorAll('select').forEach(x=>x.removeAttribute('aria-invalid'));});
}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paz-privacy-tools"]) return;
  try {
    
if (!customElements.get('paz-privacy-tools')) {
  customElements.define('paz-privacy-tools', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.messages = JSON.parse(this.querySelector('[data-privacy-messages]').textContent);
      this.banner = this.querySelector('[data-cookie-banner]');
      this.cookieDialog = this.querySelector('[data-cookie-dialog]');
      this.saleDialog = this.querySelector('[data-sale-dialog]');
      this.accessibilityDialog = this.querySelector('[data-accessibility-dialog]');
      this.restoreAccessibility();
      this.addEventListener('click', event => {
        const target = event.target.closest('button,a');
        if (!target) return;
        if (target.hasAttribute('data-open-cookies')) { event.preventDefault(); this.openCookies(); }
        if (target.hasAttribute('data-open-privacy')) { event.preventDefault(); this.showDialog(this.saleDialog); this.refreshSale(); this.loadAPI().then(() => this.refreshSale()).catch(() => this.saleMessage(this.messages.error)); }
        if (target.hasAttribute('data-open-accessibility')) this.showDialog(this.accessibilityDialog);
        if (target.hasAttribute('data-close-dialog')) target.closest('dialog').close();
        if (target.hasAttribute('data-consent-all')) this.saveCookies({ analytics: target.dataset.consentAll === 'true', marketing: target.dataset.consentAll === 'true', preferences: target.dataset.consentAll === 'true' });
        if (target.hasAttribute('data-consent-save')) this.saveCookies(Object.fromEntries(Array.from(this.querySelectorAll('[data-consent-category]')).map(input => [input.dataset.consentCategory, input.checked])));
        if (target.hasAttribute('data-sale-optout')) this.optOut();
        if (target.hasAttribute('data-privacy-retry')) { this.apiPromise = null; this.openCookies(); }
        if (target.hasAttribute('data-accessibility-reset')) { this.querySelectorAll('[data-accessibility]').forEach(input => { input.checked = false; }); this.saveAccessibility(); }
      });
      this.addEventListener('change', event => { if (event.target.hasAttribute('data-accessibility')) this.saveAccessibility(); });
      this.onConsent = () => { const state = this.api ? this.api.currentVisitorConsent() : {}; this.banner.hidden = !['analytics','marketing','preferences'].every(key => !state[key]); this.suppressDuplicateBanner(); this.populateCookies(); this.refreshSale(); };
      document.addEventListener('visitorConsentCollected', this.onConsent);
      this.loadAPI().then(api => {
        this.populateCookies();
        const state = api.currentVisitorConsent();
        const noChoice = ['analytics','marketing','preferences'].every(key => !state[key]);
        this.banner.hidden = !noChoice;
        this.suppressDuplicateBanner();
      }).catch(() => {});
      this.nativeObserver = new MutationObserver(() => this.suppressDuplicateBanner());
      this.nativeObserver.observe(document.body, { childList: true, subtree: true });
    }
    loadAPI() {
      if (this.api) return Promise.resolve(this.api);
      if (this.apiPromise) return this.apiPromise;
      this.apiPromise = new Promise((resolve, reject) => {
        let attempts = 0;
        const start = () => {
          if (window.Shopify && window.Shopify.customerPrivacy) { this.api = window.Shopify.customerPrivacy; resolve(this.api); return; }
          if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
            const deadline = setTimeout(() => reject(new Error('timeout')), 10000);
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
              clearTimeout(deadline);
              if (error || !window.Shopify.customerPrivacy) reject(new Error('unavailable'));
              else { this.api = window.Shopify.customerPrivacy; resolve(this.api); }
            });
            return;
          }
          if (++attempts > 30) { reject(new Error('unavailable')); return; }
          this.loadTimer = setTimeout(start, 100);
        };
        start();
      });
      return this.apiPromise;
    }
    suppressDuplicateBanner() {
      const native = document.querySelector('#shopify-pc__banner');
      if (native && getComputedStyle(native).display !== 'none' && getComputedStyle(native).visibility !== 'hidden') this.banner.hidden = true;
    }
    showDialog(dialog) { if (!dialog.open) dialog.showModal(); }
    async openCookies() {
      this.showDialog(this.cookieDialog);
      this.cookieMessage(this.messages.loading);
      this.setBusy(true);
      try { await this.loadAPI(); this.populateCookies(); this.cookieMessage(''); this.querySelector('[data-privacy-retry]').hidden = true; }
      catch { this.cookieMessage(this.messages.error); this.querySelector('[data-privacy-retry]').hidden = false; }
      finally { this.setBusy(!this.api); }
    }
    populateCookies() {
      if (!this.api) return;
      const state = this.api.currentVisitorConsent();
      this.querySelectorAll('[data-consent-category]').forEach(input => { input.checked = state[input.dataset.consentCategory] === 'yes'; });
    }
    writeConsent(values) {
      return this.loadAPI().then(api => new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('timeout')), 10000);
        api.setTrackingConsent(values, result => {
          clearTimeout(timer);
          if (result && result.error) reject(new Error('save failed'));
          else resolve();
        });
      }));
    }
    async saveCookies(values) {
      this.setBusy(true);
      try { await this.writeConsent(values); this.banner.hidden = true; this.cookieDialog.close(); this.populateCookies(); this.toast(this.messages.saved); }
      catch { this.showDialog(this.cookieDialog); this.cookieMessage(this.messages.error); this.querySelector('[data-privacy-retry]').hidden = false; }
      finally { this.setBusy(false); }
    }
    refreshSale() {
      this.querySelector('[data-gpc-note]').hidden = navigator.globalPrivacyControl !== true;
      if (!this.api) return;
      const optedOut = this.api.currentVisitorConsent().sale_of_data === 'no';
      this.querySelector('[data-sale-optout]').disabled = optedOut;
      this.saleMessage(optedOut ? this.messages.opted_out : '');
    }
    async optOut() {
      const button = this.querySelector('[data-sale-optout]'); button.disabled = true;
      try { await this.writeConsent({ sale_of_data: false }); this.refreshSale(); this.saleMessage(this.messages.opted_out); }
      catch { button.disabled = false; this.saleMessage(this.messages.error); }
    }
    setBusy(busy) { this.querySelectorAll('[data-consent-all],[data-consent-save]').forEach(button => { button.disabled = busy; }); }
    cookieMessage(text) { this.querySelector('[data-privacy-status]').textContent = text; }
    saleMessage(text) { this.querySelector('[data-sale-status]').textContent = text; }
    toast(text) { const toast = this.querySelector('[data-privacy-toast]'); toast.textContent = text; toast.hidden = false; clearTimeout(this.toastTimer); this.toastTimer = setTimeout(() => { toast.hidden = true; }, 5000); }
    restoreAccessibility() {
      try { const values = JSON.parse(localStorage.getItem('paz-accessibility') || '{}'); this.querySelectorAll('[data-accessibility]').forEach(input => { input.checked = values[input.dataset.accessibility] === true; }); } catch {}
      this.applyAccessibility();
    }
    applyAccessibility() {
      const classes = { reading: 'paz-reading', contrast: 'paz-contrast', motion: 'paz-reduce-motion', links: 'paz-links' };
      this.querySelectorAll('[data-accessibility]').forEach(input => document.body.classList.toggle(classes[input.dataset.accessibility], input.checked));
      document.dispatchEvent(new CustomEvent('paz:motion-change'));
    }
    saveAccessibility() {
      const values = Object.fromEntries(Array.from(this.querySelectorAll('[data-accessibility]')).map(input => [input.dataset.accessibility, input.checked]));
      try { localStorage.setItem('paz-accessibility', JSON.stringify(values)); } catch {}
      this.applyAccessibility();
    }
    disconnectedCallback() { clearTimeout(this.loadTimer); clearTimeout(this.toastTimer); if (this.nativeObserver) this.nativeObserver.disconnect(); document.removeEventListener('visitorConsentCollected', this.onConsent); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
